import React from 'react'
import { isInsuranceLogin } from 'tools/auth'
import InsurerNbDetails from './insurerNbDetails'
import CarrierAndNBAgentsDetailsTab from './carrierAndAgentNbDetails'

const NbDetails: React.FC = () => {
  return isInsuranceLogin() ? <InsurerNbDetails /> : <CarrierAndNBAgentsDetailsTab />
}

export default NbDetails
